export enum ClaimEnum {
    CanSearchProduct = "CanSearchProduct",
    CanEditProduct = "CanEditProduct",
    CanUploadPDS = "CanUploadPDS",
    CanUploadDocument = "CanUploadDocument",
    CANDOANYTHING = "CANDOANYTHING",
    CanEditDocument = "CanEditDocument",
    CanDeleteProduct = "CanDeleteProduct",
    CanSearchMaterial = "CanSearchMaterial",
    CanUploadTechSpecs = "CanUploadTechSpecs",
    CanPrintPackageLabel = "CanPrintPackageLabel",
    CanShowLog = "CanShowLog",
    CanImpersonate = "CanImpersonate",
    CanUploadGenericDocument = "CanUploadGenericDocument",
    CanManageCQC = "CanManageCQC",
    CanReportDocuments = "CanReportDocuments",
    CanReportProducts = "CanReportProducts",
    CanManageLubTable = "CanManageLubTable",
    CanViewLubTable = "CanViewLubTable",
    CanManageCommunications = "CanManageCommunications",
    CanManageCommunicationCategories = "CanManageCommunicationCategories",
    CanManageCommunicationsForCountry = "CanManageCommunicationsForCountry",
    CanShowCommunications = "CanShowCommunications",
    CanViewElmah = "CanViewElmah",
    CanExportZip = "CanExportZip",
    CanManageSigns = "CanManageSigns",
    CanUploadMaterialInfo = "CanUploadMaterialInfo",
    CanManageNet20 = "CanManageNet20",
    CanAdminNet20 = "CanAdminNet20",
    CanAdminPpe = "CanAdminPpe",
    CanManagePpe = "CanManagePpe",
    CanAdmin = "CanAdmin",
    CanViewPackaging = "CanViewPackaging",
    CanDownloadGeolocator = "CanDownloadGeolocator",
    CanViewMaterialLabel = "CanViewMaterialLabel",
    CanEditMaterialLabel = "CanEditMaterialLabel",    
    CanManageEmergencyContacts = "CanManageEmergencyContacts",
    CanShowQRCode = "CanShowQRCode",

}